import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { get } from '../../asignacion-horario/services/General.service'
/*
GET /schoolapi/utils/busquedas
 
{
  "opcion": "CAT_UNIDADES",
  "idgrado": "0101",
  "Idsede": "01"
}
*/

const useUnidades = (initialState, urlSchoolApi) => {
    const headersApi = useSelector(state => state.url.headersAPI);
    const [unidades, setUnidades] = useState(initialState);

    const getData = async ()  => {
        const data = await get({headers: headersApi, urlSchool: urlSchoolApi})
        console.log(data)
        setUnidades(() => data)
    }

    useEffect(() => {
        getData()
    }, [])
    

  return (
    [unidades]
  )
}

export default useUnidades